module.exports = __webpack_public_path__ + "img/C003_R_home slider.003e0bc0.jpg";